<template>
  <div id="wrapper">
    <header-area></header-area>
    <router-view></router-view>
    <common-loading></common-loading>
  </div>
</template>

<script>
import HeaderArea from "@/components/mobile/HeaderArea";
export default {
  name: "MobileReserveLayout",
  components: {HeaderArea}
}
</script>

<style scoped>

</style>